// extracted by mini-css-extract-plugin
export default {"reportsCard":"reportsCard_reportsCard__IRUCU","add_report":"reportsCard_add_report__GwFyI","buttons":"reportsCard_buttons__zCAyc","customerName":"reportsCard_customerName__38ISM"};